import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {
    export class TikiBay_Responsive extends SlotGameType1_Responsive {
        // override default factory with one that creates custom freegame

        

        protected override helpFactory: IHelpFactory = new TikiBayHelpFactory();

        //LED COLOR
		protected override ColorLed:string="36,255,149\n";

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "TikiBay") {
            super(multigameParams, initData, gameName);
            this.spinnableReelsParams.topBorderWidth = 6;
            this.spinnableReelsParams.bottomBorderWidth = 6;
        }
    }

    class TikiBayHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new TikiBayHelp(params);
        }
    }

    class TikiBayHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }


// }
